import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  "aria-describedby": "data-table-genesis",
  class: "w-full mt-8"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "py-1 px-2 bg-white rounded border border-gray-lp-400 text-gray-lp-600",
  style: {"box-shadow":"0 0 2px 0.5px #e0e0e0"}
}, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createVNode("path", {
      fill: "currentColor",
      d: "M6 10c0 .53-.21 1.04-.586 1.414C5.04 11.79 4.53 12 4 12c-.53 0-1.04-.21-1.414-.586C2.21 11.04 2 10.53 2 10c0-.53.21-1.04.586-1.414C2.96 8.21 3.47 8 4 8c.53 0 1.04.21 1.414.586C5.79 8.96 6 9.47 6 10zm6 0c0 .53-.21 1.04-.586 1.414C11.04 11.79 10.53 12 10 12c-.53 0-1.04-.21-1.414-.586C8.21 11.04 8 10.53 8 10c0-.53.21-1.04.586-1.414C8.96 8.21 9.47 8 10 8c.53 0 1.04.21 1.414.586C11.79 8.96 12 9.47 12 10zm4 2c.53 0 1.04-.21 1.414-.586C17.79 11.04 18 10.53 18 10c0-.53-.21-1.04-.586-1.414C17.04 8.21 16.53 8 16 8c-.53 0-1.04.21-1.414.586C14.21 8.96 14 9.47 14 10c0 .53.21 1.04.586 1.414.375.375.884.586 1.414.586z"
    })
  ])
], -1)
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("table", _hoisted_1, [
    _createVNode("thead", null, [
      _createVNode("tr", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
          return (_openBlock(), _createBlock("th", {
            id: `${_ctx.replaceWhiteSpaces(column.name)}-${index}`,
            key: index,
            class: 
            `${
              column.styleHead
            } font-semibold bg-gray-lp-700 text-12px xxl:text-14px px-4 py-4 text-black-lp-200 ${index ===
              0 && 'rounded-l-lg'} ${index === _ctx.columns.length - 1 &&
              'rounded-r-lg'}`
          
          }, _toDisplayString(column.name), 11, ["id"]))
        }), 128))
      ])
    ]),
    _createVNode("tbody", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
        return (_openBlock(), _createBlock("tr", {
          key: index,
          onClick: ($event: any) => (_ctx.onClick(item)),
          class: _ctx.isOnClick && 'cursor-pointer hover:bg-gray-lp-100'
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, indexColumn) => {
            return (_openBlock(), _createBlock("td", {
              key: indexColumn,
              class: 
            `px-4 py-6 xl:py-6 text-12px xxl:text-14px border-b border-gray-lp-400 ${indexColumn ===
              _ctx.columns.length - 1 && 'text-center'}`
          
            }, [
              (indexColumn === _ctx.columns.length - 1)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    onClick: 
              event => {
                _ctx.onOpenAttachment(item, index, !_ctx.isOpenAttachment);
                event.stopPropagation();
              }
            ,
                    class: "focus:outline-none"
                  }, [
                    _hoisted_2
                  ], 8, ["onClick"]))
                : _withDirectives((_openBlock(), _createBlock("div", _hoisted_3, null, 512)), [
                    [_directive_sanitize_html, column.render(item, index)]
                  ])
            ], 2))
          }), 128))
        ], 10, ["onClick"]))
      }), 128))
    ])
  ]))
}